import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ComingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 30);

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchDate.getTime() - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => setIsSubmitted(false), 3000);
      setEmail('');
    }
  };

  // Variantes de animação
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12
      }
    }
  };

  const floatVariants = {
    animate: {
      y: [-10, 10, -10],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const pulseVariants = {
    animate: {
      scale: [1, 1.05, 1],
      opacity: [0.8, 1, 0.8],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const numberVariants = {
    initial: { scale: 0.5, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.5, opacity: 0 }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;800;900&display=swap');
        
        .coming-soon-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Inter', sans-serif;
        }

        .bg-animation {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .bg-animation span {
          position: absolute;
          width: 50px;
          height: 50px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
        }

        .content-wrapper {
          position: relative;
          z-index: 10;
          text-align: center;
          padding: 2rem;
        }

        .logo-stream {
          font-size: 5rem;
          font-weight: 900;
          background: linear-gradient(45deg, #ff006e, #8338ec, #3a86ff, #06ffa5);
          background-size: 300% 300%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientShift 8s ease infinite;
          letter-spacing: -3px;
          margin-bottom: 0.5rem;
        }

        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .main-title {
          color: #ffffff;
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 1.5rem;
          line-height: 1.1;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.7);
          font-size: 1.25rem;
          margin-bottom: 4rem;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 300;
          line-height: 1.6;
        }

        .countdown-container {
          display: flex;
          justify-content: center;
          gap: 1.5rem;
          margin-bottom: 4rem;
          flex-wrap: wrap;
        }

        .countdown-item {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 2rem;
          min-width: 140px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          position: relative;
          overflow: hidden;
        }

        .countdown-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
          transition: 0.5s;
        }

        .countdown-item:hover::before {
          left: 100%;
        }

        .countdown-number {
          font-size: 3.5rem;
          font-weight: 900;
          color: #ffffff;
          display: block;
          line-height: 1;
          font-variant-numeric: tabular-nums;
        }

        .countdown-label {
          color: rgba(255, 255, 255, 0.5);
          text-transform: uppercase;
          font-size: 0.85rem;
          letter-spacing: 3px;
          margin-top: 0.75rem;
          font-weight: 600;
        }

        .notify-section {
          max-width: 500px;
          margin: 0 auto 4rem;
        }

        .notify-form {
          display: flex;
          gap: 0.75rem;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(20px);
          border-radius: 100px;
          padding: 0.5rem;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .notify-input {
          background: transparent;
          border: none;
          color: white;
          padding: 1rem 1.5rem;
          flex: 1;
          outline: none;
          font-size: 1rem;
        }

        .notify-input::placeholder {
          color: rgba(255, 255, 255, 0.4);
        }

        .notify-btn {
          background: linear-gradient(45deg, #ff006e, #8338ec);
          border: none;
          border-radius: 100px;
          padding: 1rem 2.5rem;
          color: white;
          font-weight: 700;
          cursor: pointer;
          font-size: 1rem;
          white-space: nowrap;
          position: relative;
          overflow: hidden;
        }

        .success-message {
          background: rgba(6, 255, 165, 0.2);
          color: #06ffa5;
          padding: 1rem 2rem;
          border-radius: 100px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          backdrop-filter: blur(10px);
        }

        .features-preview {
          display: flex;
          justify-content: center;
          gap: 4rem;
          flex-wrap: wrap;
        }

        .feature-item {
          color: rgba(255, 255, 255, 0.8);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
          font-size: 1rem;
          font-weight: 500;
        }

        .feature-icon-wrapper {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.75rem;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .particles {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }

        .particle {
          position: absolute;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 50%;
        }

        @media (max-width: 768px) {
          .logo-stream { font-size: 3rem; }
          .main-title { font-size: 2.25rem; }
          .countdown-item { min-width: 100px; padding: 1.5rem 1rem; }
          .countdown-number { font-size: 2.5rem; }
          .features-preview { gap: 2rem; }
          .notify-form { flex-direction: column; border-radius: 24px; }
          .notify-btn { width: 100%; }
        }
      `}</style>

      <div className="coming-soon-page">
        {/* Partículas de fundo animadas */}
        <div className="particles">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="particle"
              style={{
                width: Math.random() * 4 + 1 + 'px',
                height: Math.random() * 4 + 1 + 'px',
                left: Math.random() * 100 + '%',
                top: Math.random() * 100 + '%',
              }}
              animate={{
                y: [0, -100, 0],
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: Math.random() * 10 + 10,
                repeat: Infinity,
                delay: Math.random() * 5,
              }}
            />
          ))}
        </div>

        <div className="container">
          <motion.div 
            className="content-wrapper"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* Logo */}
            <motion.div variants={itemVariants}>
              <motion.h1 
                className="logo-stream"
                animate={{ 
                  textShadow: [
                    "0 0 20px rgba(255,0,110,0.5)",
                    "0 0 40px rgba(131,56,236,0.5)",
                    "0 0 20px rgba(255,0,110,0.5)"
                  ]
                }}
                transition={{ duration: 3, repeat: Infinity }}
              >
                STREAMING+
              </motion.h1>
            </motion.div>

            {/* Título */}
            <motion.h2 
              className="main-title"
              variants={itemVariants}
            >
              Estamos Preparando
              <br />
              <motion.span
                style={{ 
                  background: "linear-gradient(45deg, #ff006e, #8338ec)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
                animate={{ opacity: [0.8, 1, 0.8] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                Algo Incrível
              </motion.span>
            </motion.h2>

            {/* Subtítulo */}
            <motion.p 
              className="subtitle"
              variants={itemVariants}
            >
              Uma nova experiência de streaming está chegando. 
              Prepare-se para conteúdo exclusivo com a qualidade Gigabyte que você já conhece.
            </motion.p>

            {/* Contador */}
            <motion.div 
              className="countdown-container"
              variants={itemVariants}
            >
              {[
                { value: timeLeft.days, label: 'Dias' },
                { value: timeLeft.hours, label: 'Horas' },
                { value: timeLeft.minutes, label: 'Minutos' },
                { value: timeLeft.seconds, label: 'Segundos' }
              ].map((item, index) => (
                <motion.div 
                  key={item.label}
                  className="countdown-item"
                  whileHover={{ 
                    scale: 1.05, 
                    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                    borderColor: "rgba(255,255,255,0.3)"
                  }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <AnimatePresence mode="wait">
                    <motion.span
                      key={item.value}
                      className="countdown-number"
                      variants={numberVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      transition={{ duration: 0.3 }}
                    >
                      {String(item.value).padStart(2, '0')}
                    </motion.span>
                  </AnimatePresence>
                  <div className="countdown-label">{item.label}</div>
                </motion.div>
              ))}
            </motion.div>

            {/* Formulário de notificação */}
            <motion.div 
              className="notify-section"
              variants={itemVariants}
            >
              <AnimatePresence mode="wait">
                {!isSubmitted ? (
                  <motion.form 
                    key="form"
                    className="notify-form"
                    onSubmit={handleSubmit}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                  >
                    <input 
                      type="email" 
                      className="notify-input" 
                      placeholder="Digite seu e-mail para ser notificado"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <motion.button 
                      type="submit"
                      className="notify-btn"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Me Avise!
                    </motion.button>
                  </motion.form>
                ) : (
                  <motion.div 
                    key="success"
                    className="success-message"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                  >
                    <span>✓</span>
                    <span>Você será notificado!</span>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>

            {/* Features */}
            <motion.div 
              className="features-preview"
              variants={itemVariants}
            >
              {[
                { icon: '🎬', label: 'Conteúdo Exclusivo' },
                { icon: '📱', label: 'Multiplataforma' },
                { icon: '⚡', label: 'Os melhores streamings ' }
              ].map((feature, index) => (
                <motion.div 
                  key={feature.label}
                  className="feature-item"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1 + (index * 0.2) }}
                  whileHover={{ y: -5 }}
                >
                  <motion.div 
                    className="feature-icon-wrapper"
                    animate={{ rotate: [0, 5, -5, 0] }}
                    transition={{ duration: 4, repeat: Infinity, delay: index }}
                  >
                    {feature.icon}
                  </motion.div>
                  <span>{feature.label}</span>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;